import React from 'react';
import {
  Box,
  Link as MuiLink,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';

// ICONS
import ContactIcon from '../icons/ContactIcon';
import MessagesIcon from '../icons/MessagesIcon';
import WarningIcon from '../icons/WarningIcon';
import InvoiceIcon from '../icons/InvoiceIcon';
import CampaignIcon from '../icons/CampaignIcon';
import CreditsIcon from '../icons/CreditsIcon';

export default function CardWrapper({
  title,
  subtitle,
  icon,
  enableTitleUnderline,
  goToLink,
  goToLinkState,
  goToLinkText,
  goToLinkSetTimeRange,
  children,
  navigate,
  sx,
}) {
  const iconChoices = {
    campaign: <CampaignIcon sx={{ width: '100%', height: '100%' }} />,
    contact: <ContactIcon sx={{ width: '100%', height: '100%' }} />,
    credits: <CreditsIcon sx={{ width: '100%', height: '100%' }} />,
    messages: <MessagesIcon sx={{ width: '100%', height: '100%' }} />,
    warning: <WarningIcon sx={{ width: '100%', height: '100%' }} />,
    invoice: <InvoiceIcon sx={{ width: '100%', height: '100%' }} />,
  };

  const handlePageNavigation = () => {
    if (goToLink) {
      goToLinkSetTimeRange &&
        localStorage.setItem('timeRange', goToLinkSetTimeRange);
      let state = {
        state: goToLinkState ? goToLinkState : null,
      };
      navigate(goToLink, state);
    }
  };

  return (
    <Paper
      sx={{
        borderRadius: 4,
        width: '100%',
        paddingX: 4,
        paddingTop: 2.5,
        paddingBottom: 2.5,
        position: 'relative',
        display: 'flex',
        ...sx,
      }}
      elevation={0}
    >
      <Box
        sx={{
          color: 'grey.200',
          position: 'absolute',
          top: 4,
          left: -8,
          width: 52,
          height: 52,
          zIndex: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {iconChoices[icon]}
      </Box>

      <Stack sx={{ position: 'relative', zIndex: 1, flex: 1 }}>
        <Typography
          variant="h2"
          sx={{
            marginBottom:
              !goToLink && !enableTitleUnderline && !subtitle ? 2.2 : 0,
          }}
        >
          {title}
        </Typography>

        {enableTitleUnderline && <Divider sx={{ marginY: 1 }} />}

        {((goToLink && goToLinkText) || subtitle) && (
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: subtitle ? 'space-between' : 'flex-end',
            }}
          >
            {subtitle && (
              <Typography variant="subtitle1">{subtitle}</Typography>
            )}

            {goToLink && goToLinkText && (
              <MuiLink
                tabIndex={0}
                onClick={handlePageNavigation}
                sx={{
                  fontWeight: 400,
                  fontSize: 12,
                  width: 'auto',
                }}
              >
                {goToLinkText}
              </MuiLink>
            )}
          </Box>
        )}

        {children}
      </Stack>
    </Paper>
  );
}
